export default {
  translation: {
    "app": {
      "title": "Matrix Чат"
    },
    "login": {
      "title": "Вхід",
      "username": "Логін",
      "password": "Пароль",
      "loginButton": "Увійти",
      "usernameRequired": "Введіть логін",
      "passwordRequired": "Введіть пароль",
      "invalidCredentials": "Невірне ім'я користувача або пароль",
      "loginError": "Помилка входу: {{error}}",
      "loginFailed": "Не вдалося увійти. Будь ласка, спробуйте знову."
    },
    "header": {
      "logout": "Вийти",
      "userManagement": "Управління користувачами",
      "reconnect": "Перепідключитися"
    },
    "chat": {
      "selectRoom": "Виберіть кімнату для початку спілкування",
      "loading": "Завантаження кімнат...",
      "connectionLost": "З'єднання втрачено",
      "reconnecting": "Перепідключення...",
      "connected": "Підключено",
      "disconnected": "Відключено",
      "reconnectButton": "Перепідключитися",
      "onlineMembersCount": "{{count}} онлайн",
      "typing": "{{user}} друкує...",
      "reply": "Відповісти",
      "edit": "Редагувати",
      "delete": "Видалити",
      "cancel": "Скасувати",
      "save": "Зберегти",
      "messageInput": "Введіть повідомлення...",
      "uploadFile": "Завантажити файл",
      "sendMessage": "Надіслати повідомлення",
      "editMessage": "Редагувати повідомлення",
      "replyTo": "Надрукуйте вашу відповідь...",
      "editingMessage": "Редагування повідомлення",
      "edited": "Відредаговано",
      "earlier": "раніше",
      "addReaction": "Додати реакцію",
      "messageActions": "Дії з повідомленням",
      "deleteMessage": "Видалити повідомлення",
      "deleteMessageConfirm": "Ви впевнені, що хочете видалити це повідомлення? Це дія не може бути скасована.",
      "deletedMessage": "Це повідомлення було видалено"
    },
    "notifications": {
      "newMessage": "Нове повідомлення",
      "connectionProblem": "Проблеми з підключенням. Повторна спроба через {{seconds}} сек.",
      "serverUnavailable": "Сервер недоступний. Повторіть спробу пізніше.",
      "alreadyConnecting": "Вже виконується підключення, будь ласка зачекайте",
      "tooFrequentAttempts": "Зачекайте, занадто часті спроби ({{seconds}}с)",
      "sessionExpired": "Ваша сесія закінчилася. Будь ласка, увійдіть знову."
    },
    "members": {
      "online": "Онлайн",
      "offline": "Офлайн",
      "unavailable": "Відсутній",
      "unknown": "Невідомо",
      "members": "Учасники",
      "justNow": "тільки що",
      "minutes": "хв назад",
      "hours": "год назад",
      "days": "дн назад",
      "connections": "з'єднань",
      "moderator": "Модератор",
      "lastActivity": "Остання активність",
      "support": "Підтримка",
      "loadingRoomMembers": "Завантаження учасників кімнати {{roomId}}...",
      "selectRoomForMembers": "Виберіть кімнату для просмотру учасників",
      "myTeam": "Моя команда",
      "noMembers": "Немає учасників",
      "updated": "Оновлено",
      "updatedAuto": "авто"
    },
    "language": {
      "english": "English",
      "russian": "Русский",
      "ukrainian": "Українська"
    },
    "fileAttachment": {
      "attachments": "Вкладення",
      "unknown": "Невідомий файл",
      "unknownSize": "Невідомий розмір",
      "download": "Завантажити",
      "view": "Перегляд",
      "dropFileHere": "Перетягніть файл сюди",
      "uploadFiles": "Завантажити файли",
      "clickOrDragFiles": "Натисніть або перетягніть файли в цю область для завантаження"
    },
    "emojiPicker": {
      "title": "Виберіть емодзі",
      "description": "Виберіть емодзі для відправлення",
      "search": "Пошук",
      "addReaction": "Натисніть для додавання",
      "removeReaction": "Натисніть для видалення"
    },
    "messageList": {
      "loading": "Завантаження повідомлень...",
      "loadMore": "Завантажити попередні повідомлення",
      "loadMoreDeep": "Завантажити більш старі повідомлення",
      "reachedStartOfHistory": "Досягнуто початку історії повідомлень"
    },
    "notificationSettings": {
      "title": "Налаштування повідомлень",
      "soundNotifications": "Звукові повідомлення",
      "close": "Закрити",
      "enableSound": "Включити звук",
      "disableSound": "Вимкнути звук",
      "listen": "Прослухати",
      "soundSelection": "Вибір звуку повідомлення"
    },
    "roomsList": {
      "noMessages": "Немає повідомлень",
      "emptyMessage": "Пусте повідомлення",
      "chatRooms": "Кімнати"
    },
    "serviceMessage": {
      "join": "теперь з нами",
      "leave": "покинул",
      "restricted": "лише для"
    },
    "userManagement": {
      "noWebSocketConnection": "Немає з'єднання з WebSocket",
      "userAdded": "Користувач {{username}} успішно доданий",
      "userUpdated": "Користувач {{username}} успішно оновлений",
      "userDeleted": "Користувач {{username}} успішно видалений",
      "confirmDeletion": "Підтвердження видалення",
      "confirmDeletionContent": "Ви впевнені, що хочете видалити користувача \"{{username}}\"?",
      "username": "Ім'я користувача", 
      "created": "Створено",
      "actions": "Дії",
      "noPermission": "У вас немає дозволу на управління користувачами",
      "userManagement": "Управління користувачами",
      "addUser": "Додати користувача",  
      "addNewUser": "Додати нового користувача",
      "usernameRequired": "Введіть ім'я користувача",
      "password": "Пароль",
      "passwordRequired": "Введіть пароль",
      "cancel": "Скасувати",
      "changePassword": "Змінити пароль для {{username}}",
      "newPassword": "Новий пароль",
      "updatePassword": "Оновити пароль",
      "newPasswordRequired": "Введіть новий пароль",
      "userNotSelected": "Користувач не вибраний",
      "deletingUser": "Видалення користувача...",
      "editPassword": "Змінити пароль для {{username}}",
      "deleteUser": "Видалити користувача {{username}}",
      "searchUsername": "Пошук по імені користувача",
      "updateList": "Оновити список",
      "noData": "Немає даних",
      "delete": "Видалити",
      "attention": "Увага",
      "ifUserIsAuthorized": "Якщо користувач в даний момент авторизований, його сесія буде примусово завершена."
    },
    "search": {
      "title": "Пошук повідомлень",
      "placeholder": "Пошук в цій кімнаті...",
      "button": "Знайти",
      "searching": "Пошук...",
      "resultsFound": "Знайдено результатів: {{count}}",
      "noResults": "Нічого не знайдено",
      "tryDifferent": "Спробуйте інший пошуковий запит",
      "startSearching": "Введіть пошуковий запит для пошуку повідомлень",
      "newestFirst": "Спочатку нові",
      "oldestFirst": "Спочатку старі",
      "sortNewestFirst": "Сортировка: спочатку нові",
      "sortOldestFirst": "Сортировка: спочатку старі",
      "tip": "Підказка: Пошук не чутливий до регістру",
      "total": "Всього"
    },
    "common": {
      "more": "більше"
    },
    "message": {
      "edited": "відредаговано"
    }
  }
};
